import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule as MatButtonModule } from '@angular/material/button';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonLayoutModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { ImageViewEditorComponent } from './component/image-view-editor/image-view-editor.component';
import { ImageViewComponent } from './component/image-view/image-view.component';


@NgModule({
  declarations: [
    ImageViewComponent,
    ImageViewEditorComponent
  ],
  imports: [
    CommonModule,
    ApplicationClientCommonModule,
    CommonLayoutModule,
    CommonTranslationModule,
    MatButtonModule
  ]
})
export class ImageViewModule { }
